import _ from 'underscore';
import AssociationsEditorBase from '@bingads-webui-campaign-legacy/adextension-associations-editor/view/index';
import dialogDecorator from '@bingads-webui-component-legacy/dialog/dialogDecorator';
import SharedRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repository';
import EditorView from '@bingads-webui-campaign-legacy/adextension-actionlink/view/extensionEditor';
import { universalItemTemplate } from '../template';
import { panelDecorator } from '@bingads-webui-campaign-react/panel-decorator';

const schema = window.globalLegacySchema.get('ActionAdExtension');
const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');

const dialogOptions = {
  position: 'center',
  maxWidth: 1000,
};

const i18nKeys = {
  title: 'AdExtensions_Actionlink_Editor_Title',
  subtitle: ['NewCampaign_AddActionlinkAdExtension_Subtitle'],
  /* eslint-disable */
  library_title: 'AdExtensions_Actionlink_Editor_Available',
  selected_title: 'AdExtensions_Actionlink_Editor_Selected',
  create_link: 'AdExtensions_Actionlink_Editor_CreateNew',
  create_title: 'AdExtensions_Actionlink_Dialog_Title_Add',
  delete_btn: 'AdExtensions_Actionlink_Editor_Delete',
  delete_confirm: 'AdExtensions_Actionlink_Delete_Warning',
  edit_btn: 'AdExtensions_Actionlink_Editor_Edit',
  edit_title: 'AdExtensions_Actionlink_Dialog_Title_Edit',
  /* eslint-enable */
  inlineAlert: 'AdExtensions_Max_Select_Notification',
};

const View = AssociationsEditorBase.extend({
  initialize(options = {}) {
    const Editor = options && options.usePanel ? panelDecorator(EditorView, {
      i18n,
      panelReadyAriaLabel: i18n.getString('Association editor side panel opened'),
      panelClassName: options.panelClassName,
    }) :
      dialogDecorator.decorate(EditorView, dialogOptions);

    _.extend(options, {
      idField: 'Id',
      data: new SharedRepository({
        schema,
        afterChangeComitted: () => {
          if (_.isFunction(options.updateContext)) {
            options.updateContext(['AccountAdExtensionsGrid', 'CampaignAdExtensionsGrid', 'AdGroupAdExtensionsGrid']);
          }
        },
      }),
      template: {
        previewTemplateType: 'function',
        preview: universalItemTemplate,
        rowTemplate: universalItemTemplate,
      },
      maxSelectedItemsCount: 20,
      CreateForm: Editor,
      EditForm: Editor,
      i18nKeys: _.extend({}, i18nKeys, options.i18nKeys || {}),
      extensionType: 'ActionLinkExtension',
    });

    AssociationsEditorBase.prototype.initialize.call(this, options);
  },
});

export default View;
